import { Button, Popconfirm, Space } from "antd";
import React, { useState } from "react";
import PrimaryButton from "../../../buttons/PrimaryButton";
import apiService from "../../../../../service/apiservice/apiService";
import { strings } from "../../../../../experience/utils/strings";
import { useNavigate } from "react-router-dom";
import { convertTimeToTimestamp } from "../../../../../utils/dateutils";
import { useReadMemory } from "../../../../../experience/generic/hooks/useReadMemory";
import MemoryType from "../../../../../service/memory/enum/MemoryType";
import RejectMessage from "../../../../../experience/carecoordinator/careplan/visitlist/RejectMessage";
import ApproveMessage from "../../../../../experience/carecoordinator/careplan/visitlist/ApproveMessage";

const FormActionsButtons = ({
  setFormReadOnly,
  role,
  additionalFormDetails,
  isApproveCommentsAllowed
}) => {
  const navigate = useNavigate();
  const [showCoordinatorAction, setShowCoordinatorAction] = useState(true);
  const [commentInput, setCommentInput] = useState("");
  const [approveComments, setApproveComments] = useState("");
  const user = useReadMemory(MemoryType.USER);

  const handleEdit = () => {
    setShowCoordinatorAction(!showCoordinatorAction);
    setFormReadOnly(!showCoordinatorAction);
  };

  const handleApprove = async () => {
    const payload = {
      status: "Approved",
      id: additionalFormDetails?.id,
      opportunityId: additionalFormDetails?.opportunityId,
      workforceIdentifier: additionalFormDetails?.workforceIdentifier,
      organizationIdentifier: additionalFormDetails?.organizationIdentifier,
      taskDate: additionalFormDetails?.taskDate,
      startTime: additionalFormDetails?.startTime,
      endTime: additionalFormDetails?.endTime,
      formIdentifier: additionalFormDetails?.formIdentifier,
      approveComments,
      ...(additionalFormDetails?.coordinator && { coordinatorIdentifier: user?.userIdentifier }),
    };

    await apiService.post(
      "niramayafoundation/niramayavisits/api/v1/task",
      payload,
      strings.VISIT_APPROVED_SUCCESS,
      strings.VISIT_APPROVED_ERROR
    );
    navigate(-1);
  };

  const handleReject = async () => {
    let visitComment = additionalFormDetails?.comments;
    const newComment = {
      comment: commentInput,
      identifier: user?.userIdentifier,
      fullName: user?.givenName + user?.familyName,
      time: convertTimeToTimestamp(new Date()),
    };
    const commentsToBeModified = JSON.parse(visitComment ?? "[]");
    commentsToBeModified?.push(newComment);
    visitComment = commentsToBeModified;

    const payload = {
      status: "Rejected",
      id: additionalFormDetails?.id,
      opportunityId: additionalFormDetails?.opportunityId,
      workforceIdentifier: additionalFormDetails?.workforceIdentifier,
      organizationIdentifier: additionalFormDetails?.organizationIdentifier,
      taskDate: additionalFormDetails?.taskDate,
      startTime: additionalFormDetails?.startTime,
      endTime: additionalFormDetails?.endTime,
      formIdentifier: additionalFormDetails?.formIdentifier,
      comments: JSON.stringify(visitComment),
      ...(additionalFormDetails?.coordinator && { coordinatorIdentifier: user?.userIdentifier }),
    };

    await apiService.post(
      "niramayafoundation/niramayavisits/api/v1/task",
      payload,
      strings.VISIT_REJECTED_SUCCESS,
      strings.VISIT_REJECTED_ERROR
    );
    navigate(-1);
  };

  const handleCommentInput = (e) => {
    setCommentInput(e.target.value);
  };

  return (
    <Space>
      {role === "Volunteer Coordinator" && showCoordinatorAction && (
        <>
          {additionalFormDetails?.status === "Submitted" &&
            (isApproveCommentsAllowed ? (
              <Popconfirm
                title={
                <ApproveMessage
                  commentInput={approveComments}
                  handleCommentInput={(e)=> setApproveComments(e.target.value)}
                />
              }
                placement="topLeft"
                onConfirm={handleApprove}
                okText="Confirm"
                cancelText="Cancel"
                onCancel={() => setApproveComments("")}
              >
                <Button className="primary-btn ant-btn-primary">Approve</Button>
              </Popconfirm>
            ) : (
              <PrimaryButton
                buttonText="Approve"
                handleOnClick={handleApprove}
              />
            ))}
          {additionalFormDetails?.status === "Submitted" && (
            <Popconfirm
              title={
                <RejectMessage
                  commentInput={commentInput}
                  handleCommentInput={handleCommentInput}
                />
              }
              placement="topLeft"
              onConfirm={handleReject}
              okText="Confirm"
              cancelText="Cancel"
              onCancel={() => setCommentInput("")}
            >
              <Button className="primary-btn ant-btn-primary">Reject</Button>
            </Popconfirm>
          )}
        </>
      )}
      {additionalFormDetails?.formIdentifier && (
        <PrimaryButton
          buttonText={showCoordinatorAction ? "Edit" : "Cancel"}
          handleOnClick={handleEdit}
        />
      )}
    </Space>
  );
};

export default FormActionsButtons;
